<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0>
    <v-row>
      <v-col cols="12" md="8" sm="8" lg="8">
        <v-card>
          <v-layout justify-center wrap>

            <v-flex xs12 md12>
              <v-col cols="8" md="8" sm="8" lg="8">
                <v-card class="d-flex align-center elevation-0" style="max-width: 70%">
                  <v-img :src="require('@/assets/banner/events.jpg')" />
                  <v-img style="max-width: 30%" :src="require('@/assets/reserve.png')" @click="register()" />
                </v-card>
              </v-col>

              <v-col cols="12" md="12" sm="12" lg="12">
                <v-img :src="require('@/assets/viv2025.jpg')" max-height="100%"/>
              </v-col>

              <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%" height="70%">
                <v-col cols="12" md="11" sm="11" lg="11">
                  <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%">
                    <v-layout justify-center wrap>
                      <v-flex xs12 md12>
                        <h2>Chithirai Thiru Vizha 2025</h2><br>
                        <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%">
                          நமது சார்லட் தமிழ்ச் சங்கத்தின் 2026 ஆண்டிற்கான சித்திரை
                          திருவிழா வரும் மே 31st ஆம் தேதி சனிக்கிழமை அன்று இந்து சென்டர் (முகவரி: 7400 City View
                          Drive, Charlotte NC 28212) அரங்கத்தில் வாழை இலை விருந்துடன்
                          சிறப்பாக நடத்தவுள்ளோம்.<br /><br />
                          உறுப்பினர்கள் தங்கள் திறனை வெளிப்படுத்தும் வகையில் ஆடல், பாடல்,
                          நாடகம், இசைக்கருவிகள் வாசித்தல் போன்ற பல்சுவை நிகழ்ச்சிகள்
                          மற்றும் போட்டிகளில் பங்கேற்று இந்த விழாவினை சிறப்பிக்குமாறு
                          சார்லட் தமிழ்ச் சங்கம் பணிவன்போடு கேட்டுக்கொள்கிறது.<br />
                        </v-card>

                        <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%"
                        ><br />
                        2025 Charlotte Tamil Sangam Membership -
                        <a
                          href="https://tinyurl.com/yrwxmt4y"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        ><br /><br />

                        <v-col cols="8" md="8" sm="8" lg="8">
                          <v-card class="d-flex align-left elevation-0" style="max-width: 60%">
                            Reservation will be opened soon <v-img style="max-width: 40%" :src="require('@/assets/viv_book.jpg')" />
                          </v-card>
                        </v-col>
                          
                        <b>Important Dates</b><br />
                          STEP 1: Program Registration:  April 22nd - May 2nd<br />
                          STEP 2: Participant Registration: May 3rd - May 10th<br />
                          STEP 3: Audio file Submission:  May 3rd - May 10th<br />
                          STEP 4: Drawing and Food carving Submission: May 3rd 2025<br />
                          <br />
                        <b>Chithirai Thiruvizha Program Registration</b><br /><br />
                        Program Guidelines :
                        <a
                          href="https://docs.google.com/document/d/1Ya9EKT283XPgzvkXHwEbjk7T4EVOiccW/edit?tab=t.0"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Program Enrollment Form :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLScgh_SDkTFSIQxCxxDAssjykKJYjLQ0DR2vFxyPZlYdHqyKJA/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Participant Registration Form:
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSerq1Vdhcd8xsYRJz5FVg3Z-CWZEEt3phWF0PFJhflfqezb3w/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Audio Track Submission Form :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLScp1XBcy8T78Q_oFUDFNSR1vkhn8PpQv_OK1eU5ZNMoFgAGQA/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />

                        <br /><b>Competition Registration</b><br /><br />
                        Drawing competition Enrollment Form :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLScD5H91qWaw7bh69MlEOFtX-2__uh2qcu_2f-kvi3P7igHkUA/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Veg/Fruit Competition Enrollment Form :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSfBYQjK48L76tOZLWb_307A01jnIhm4syK2Ev5vFwykGoG5Ag/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />

                        <br /><b> Volunteer Registration</b><br /><br />
                        General Volunteering :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLScVQZA8gM8P57kmSMb6qt28Tu6JrR8teZGSmxlGLzlZOzN2bQ/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        MC Volunteering :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSfpJ3wdL_yeyfKbAVBv4FUw4U-cWESSP8fs0jkI86IzCCGpzA/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Judge Volunteering :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSc_zkN3bclI0sAmabgvpipJhjO8Vcv31_YEE2gevhpxwWh6fw/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Cooking Volunteer :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeQOSQczQ1wvf8BnLYIUfjpg3Xr7AJxuJv3xgtBU7C56XRl1A/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />
                        Feedback Form :
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSeSEGYGKcZbpe-BdvAnUPaFYWvAjiG9I0oqGxTc8gc2G41zQQ/viewform"
                          target="_"
                          style="color: #8ebf42"
                          >Link</a
                        >
                        <br />

                        <br /><b>English</b><br /><br />

                        We are happy to announce that Chithirai Thiruvizha will be celebrated on Saturday, May 31st 2025 at the Hindu
                        Center Of Charlotte (Address: 7400 City View Drive, Charlotte NC
                        28212). We have shared below registration information for all
                        the competitions, cultural programs and for volunteering below.
                        We invite all members to participate in our traditional programs
                        and competitions.<br />
                        </v-card>

                        <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%">
                          <b><br>நன்றி.</b><br />
                          <b>சார்லட் தமிழ்ச் சங்கம்</b><br />
                        </v-card>

                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-col>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-col>
    
      <v-col cols="12" md="4" sm="4" lg="4"><br>
        <v-alert border="top" colored-border color="deep-purple accent-4" elevation="0">
          <v-layout>
            <v-card>
              Paarivallal Members for calendar year - 2025
              <v-card-title>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-flex md12 style="overflow: auto">
                <v-data-table :items="filteredItems" item-key="_id" dense :search="search" :headers="headers"
                  :sort-by="['firstname']" :sort-desc="[false]" v-scroll:#virtual-scroll-table="onScroll"
                  :items-per-page="20" class="elevation-0">
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.firstname }}</td>
                      <td>{{ item.membershipcategory }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-card>
          </v-layout>
        </v-alert>
      </v-col>
    </v-row>
    <br>

    <v-flex xs12 md12>
      <v-alert type="primary" icon="mdi-account" dense>Platinum Sponsors</v-alert>
      <home-images></home-images>
      <v-alert type="info" icon="mdi-web" dense>Diamond Sponsors</v-alert>
      <diamond-sponsors></diamond-sponsors>
      <extended-footer></extended-footer>
    </v-flex>

  </v-container>
</template>

<script>
import ReportServices from "@/services/ReportServices";
import HomeImages from '@/components/HomePageImages'
import DiamondSponsors from '@/components/DiamondSponsors'

export default {
  name: "SectionBlogExcerptLeftImg",
  data() {
    return {
      allMemberData: [],
      search: '',
      loading: true,
      headers: [
        { text: "#", value: "s.no" },
        { text: "Member Name", value: "firstname" },
        { text: "Membership", value: "membershipcategory" }
      ],
      texts: [
        "நமது தமிழ் சங்கத்தின் புதியதொரு உதயம். பெருமிதத்துடன் ஒரு அத்தியாயம்.நமது இளைஞர் குழு.",
        "பலவகையான திறமைகளைத் தன்னுள் கொண்ட நமது இளைய தலைமுறை அவற்றை வெளிகொணரவும், தம்மைப்போல் ஆர்வமுள்ள பிற இளைஞர்களை சந்திக்கவும், தங்களது தமிழார்வத்தையும் கலாச்சார பற்றையும் வளர்த்துக் கொள்ளவும் வேண்டுமென்ற நோக்கத்தோடு இந்த குழு ஆரம்பிக்கப்பட்டது.",
        "தமது திறமையை வெளிக்காட்டும் ஒரு வடிகாலாக மட்டும் இல்லாமல் , சமுதாயத்துக்கு அவர்களால் ஆன உதவிகளை செய்யும் ஒரு களமாகவும் இந்த இளைஞர் அமைப்பு செயல்பட்டு வருகிறது.",
      ],
    };
  },
  components: {
    HomeImages,
    DiamondSponsors
  },
  computed: {
    filteredItems() {
      return this.allMemberData.filter((i) => {
        return i.membershipcategory === "Paarivallal" && i.year === "2025";
      });
    },
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.allMemberData = (await ReportServices.index()).data;
      this.loading = false;
      this.noDataText = "No data available";
    },
    register() {
      this.$router.replace('/PaymentGateway')
    },
  },
  async mounted() {
    this.refresh();
  },
};
</script>

<style lang="scss" scoped>
#virtual-scroll-table {
  max-height: 400px;
  overflow: auto;
}
</style>